const isCypress = typeof window.Cypress !== 'undefined'

export default defineNuxtPlugin((nuxtApp) => {
  if (isCypress) {
    window.store = nuxtApp.$store
    window.eventBus = nuxtApp.$eventbus
  }
})
